<template>
    <div class="feature-slider-area section-space--pt_60">
        <div class="feature-slider position-relative">
            <div class="feature-slider__container">
                <div class="feature-slider__wrapper">
                    <swiper
                        :speed="1000"
                        :effect="'fade'"
                        :pagination="swiperOptions.pagination"
                    >
                            <swiper-slide class="feature-slider__single-slide">
                                <div class="feature-slider__single-slide-wrapper">
                                    <div class="row align-items-center">
                                        <div class="col-md-6 wow move-up">
                                            <div class="image">
                                                <img src="../assets/img/features/aeroland-clinic-image-01.png" class="img-fluid" alt="">
                                            </div>
                                        </div>
                                        <div class="col-md-6 wow move-up">
                                            <div class="content">
                                                <h4 class="title">We enable users to obtain independent, reliable power regardless of weather conditions or poor energy infrastructure</h4>
                                                <div class="text">
                                                    <p>Leveraging heavily on our experience of working with biomedical teams in remote locations of Central America and the Caribbean, our products and installation services are tailored to be reliable solutions, ideal for places like Florida or Puerto Rico.</p>
                                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                         <div class="swiper-pagination swiper-pagination--vertical swiper-pagination-1"></div>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import SwiperCore, { Pagination, EffectFade } from 'swiper/core'
    SwiperCore.use([Pagination, EffectFade])

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination--vertical',
                        type: 'bullets',
                        clickable: true
                    }
                }
            }
        },
    }
</script>

<style lang="scss">
    .feature-slider__single-slide {
        background-color: #fff;
    }
</style>